// Sénégal phone normalization (matches backend server.py normalize_senegal_phone)
// Accepted inputs → normalize to +221XXXXXXXXX (13 chars)
//   77XXXXXXX (9 digits) → +221XXXXXXXXX
//   +221XXXXXXXXX → kept
//   221XXXXXXXXX (12 digits) → prepend +
//   00221XXXXXXXXX → replace 00221 by +221
export function normalizeSenegalPhone(raw) {
  if (!raw) return null;
  let s = String(raw).replace(/[\s.\-()]/g, "");
  if (s.startsWith("00221")) s = "+221" + s.slice(5);
  else if (s.startsWith("221") && s.length === 12) s = "+" + s;
  else if (s.length === 9 && /^\d+$/.test(s)) s = "+221" + s;
  if (!/^\+221[0-9]{9}$/.test(s)) return null;
  return s;
}
